<script setup lang="ts">
  import { ref } from 'vue';
  import { useBreakpoints } from '@storefront/storefront';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String, required: true },
    headerSpecial: { type: String, required: true },
    headerType: { type: String },
    products: { type: Array, required: true },
    product: Object,
    link: String,
    enableAutoplay: Boolean,
    timeAutoplay: [Number, String],
    speed: [Number, String],
  });

  const breakpoints = useBreakpoints();

  const parameters = ref({
    breakpoints: {
      1: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
</script>
<template>
  <section v-if="products?.length > 0 && !!product" class="special-offer-block">
    <div v-if="breakpoints.lg" class="special-offer-block__special-product-wrapper">
      <span class="special-offer-block__special-text">
        {{ headerSpecial }}
      </span>
      <ProductCard :product />
    </div>
    <SfSection div :title="header" :headerType :link="link || $route('web.product.index')">
      <SfProductsCarousel :parameters :products :enableAutoplay :timeAutoplay :speed>
        <template #before v-if="!breakpoints.lg">
          <div class="special-offer-block__special-product-wrapper">
            <span class="special-offer-block__special-text">
              {{ headerSpecial }}
            </span>
            <ProductCard :product />
          </div>
        </template>
      </SfProductsCarousel>
    </SfSection>
  </section>
</template>
<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .special-offer-block {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 1rem;
    --section-gap: 1rem;
    --section-content-gap: 1rem;

    &__special-product-wrapper {
      height: 100%;
      overflow: hidden;
      border-radius: var(--section-border-radius);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      background: var(--primary-color);
      padding: 0.5rem;
    }

    &__special-text {
      padding: 0.25rem;
      background: var(--primary-color);
      text-align: center;
      font-size: 1.25rem;
      font-weight: var(--font-weight-semi);
      color: var(--foreground-on-primary-bg);
    }

    @include media.query(lg) {
      grid-template-columns: 1fr;

      &__special-product-wrapper {
        border-radius: var(--border-radius);
        gap: 0.25rem;
        padding: 0.5rem;
      }

      &__special-text {
        padding: 0.125rem 0;
        font-size: 1rem;
      }
    }
  }
</style>
